import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AUTH_MODE } from '../../constants/authMode';

const slice = createSlice({
  name: 'twoFactorAuthMode',
  initialState: AUTH_MODE.EMAIL,
  reducers: {
    setTwoFactorAuthMode(state, action: PayloadAction<AUTH_MODE>) {
      return action.payload;
    },
  },
});

export const { setTwoFactorAuthMode } = slice.actions;

export default slice.reducer;
